import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { cn } from '../lib/utils';
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'default' | 'large';
  fullWidthMobile?: boolean;
  pulse?: boolean;
};
export function CTAButton({
  children,
  href = 'https://step-class-ready.impultienda.ar/checkout',
  className = '',
  size = 'default',
  fullWidthMobile = true,
  pulse = false
}: CTAButtonProps) {
  const reducedMotion = useReducedMotion();
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    const target = document.querySelector(href);
    if (!target) return;
    event.preventDefault();
    window.history.replaceState(null, '', href);
    const destination = target.getBoundingClientRect().top + window.scrollY - 16;
    if (reducedMotion) {
      window.scrollTo(0, destination);
      return;
    }
    const start = window.scrollY;
    const distance = destination - start;
    const duration = 1300;
    const startTime = performance.now();
    const step = (currentTime: number) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 4);
      window.scrollTo(0, start + distance * easedProgress);
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  };
  return <motion.a href={href} onClick={handleClick} animate={pulse && !reducedMotion ? {
    scale: [1, 1.05, 1]
  } : undefined} transition={pulse && !reducedMotion ? {
    duration: 2.5,
    ease: 'easeInOut',
    repeat: Infinity
  } : undefined} whileHover={reducedMotion ? undefined : {
    y: -2
  }} whileTap={reducedMotion ? undefined : {
    scale: 0.985
  }} className={cn('inline-flex items-center justify-center rounded-xl bg-green font-extrabold uppercase tracking-[0.02em] text-white shadow-elevated transition-colors duration-200 hover:bg-green-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2', size === 'large' ? 'px-7 py-5 text-base sm:px-9 sm:text-lg' : 'px-6 py-4 text-sm sm:text-base', fullWidthMobile ? 'w-full sm:w-auto' : '', className)} data-id="element-62" data-mp="1s791zier3yb9">
      {children}
    </motion.a>;
}